import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Alert as AntAlert } from 'antd';
import styled from 'styled-components';
var LIGHT_GREY = '#f4f7f8';
var Alert = styled(AntAlert)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-alert-icon {\n    align-self: start;\n    margin-top: 0.286rem;\n  }\n\n  && {\n    ", "\n  }\n"])), function (props) {
  return props.monochrome && "\n      background-color: ".concat(LIGHT_GREY, ";\n      border-color: ").concat(LIGHT_GREY, ";\n\n      .ant-alert-icon {\n        color: ").concat(props.theme.colors.dark, ";\n      }\n    ");
});
export default Alert;